import type { AnyShippingMethod, InStoreDeliveryShippingMethod } from "@jti/commerce";

export const isInStoreDeliveryShippingMethod = (method: AnyShippingMethod): boolean => {
  return (
    method.type === "in-store delivery" &&
    typeof method.label === "string" &&
    typeof method.methodCode === "string" &&
    typeof method.description === "string" &&
    typeof method.lat === "number" &&
    typeof method.lon === "number" &&
    typeof method.defaultZoomLevel === "number" &&
    typeof method.storeLocatorShopDetailsPage === "string" &&
    typeof method.flotiqContentType === "string" &&
    typeof method.flotiqApiKey === "string"
  );
};

export const findInStoreDeliveryMethod = (
  methods: AnyShippingMethod[] | undefined,
  code: string | undefined
): InStoreDeliveryShippingMethod | undefined => {
  if (!methods || !code) return undefined;
  return methods.find(
    (method): method is InStoreDeliveryShippingMethod =>
      method.methodCode === code && isInStoreDeliveryShippingMethod(method)
  );
};
